import React from 'react';
import Cancel from '../../assets/cancel.svg';
import styled from 'styled-components';
import { theme } from '../../style/theme';

const Img = styled.img`
  height: 18px;
  width: 18px;
  transition: all ${theme.transitions.fast};
  opacity: 0.7;
  
  &:hover {
    opacity: 1;
    transform: scale(1.1);
  }
`;

// Fallback X if SVG is not available
const XIcon = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: ${theme.colors.neutral.gray600};
  line-height: 1;
  transition: all ${theme.transitions.fast};
  user-select: none;
  
  &:hover {
    color: ${theme.colors.neutral.gray800};
    transform: scale(1.1);
  }
`;

interface CloseButtonProps {
  onClick: () => void;
}

const CloseButton: React.FC<CloseButtonProps> = ({ onClick }) => {
  return (
    <>
      <Img 
        src={Cancel} 
        onClick={onClick}
        onError={(e) => {
          // If SVG fails to load, hide it and show fallback
          (e.target as HTMLImageElement).style.display = 'none';
          const parent = (e.target as HTMLImageElement).parentElement;
          if (parent) {
            const fallback = parent.querySelector('[data-fallback]') as HTMLElement;
            if (fallback) fallback.style.display = 'block';
          }
        }}
        alt="Close"
      />
      <XIcon 
        data-fallback
        onClick={onClick}
        style={{ display: 'none' }}
        aria-label="Close modal"
      >
        ×
      </XIcon>
    </>
  );
};

export default CloseButton;
